import AlertMessage from '../oc-alert-message';

const alertIconOptionByType = type => ['black', 'error', 'info', 'warning'].includes(type);

// eslint-disable-next-line react/prop-types
const CMSAlertMessage = ({ className, dismissable = false, message, title, type = 'black', alertIcon = true }) => (
  <AlertMessage
    alertIcon={alertIcon && alertIconOptionByType(type)}
    className={`page-alert ${className}`.trim()}
    dismissable={dismissable}
    message={message}
    title={title}
    type={type}
  />
);

export default CMSAlertMessage;
